/**
 * @param {Function} fn 闃叉姈鍑芥暟
 * @param {Number} delay 寤惰繜鏃堕棿
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 闇€瑕佽浆鎹㈢殑鏃堕棿
 * @param {String} fmt 闇€瑕佽浆鎹㈢殑鏍煎紡 濡?yyyy-MM-dd銆亂yyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}

/**
 *
 * @param {缂撳瓨key} key
 * @param {闇€瑕佸瓨鍌ㄧ殑缂撳瓨鍊紏 value
 * @param {杩囨湡鏃堕棿锛岄粯璁?琛ㄧず姘镐箙鏈夋晥} expire 24 * 3600鏄竴澶? */

// 璁剧疆缂撳瓨
export function setCache(key, value, expire = 24 * 3600) {
  console.log(value, 'value------------')
  //姣
  expire = (new Date()).getTime() + expire * 1000
  const storage = {
    v: value,
    exp: expire
  }

  try {
    localStorage.setItem(key, JSON.stringify(storage))
  } catch (e) {
    console.log(e)
  }
}

// 鍒犻櫎缂撳瓨
export function getCache(name) {
  try {
    const storage = localStorage.getItem(name) || null
    // console.log(storage, new Date().getTime(),'娓呴櫎缂撳瓨鍒犻櫎鎴愬姛---------8888888888',)
    if (storage && storage.exp < (new Date().getTime())) {
      localStorage.removeItem(name)
      return
    } else {
      // console.log('999999999999999999娌℃湁鍙垹闄ょ殑缂撳瓨')
      return storage
    }
  } catch (e) {
    console.log(e)
  }

}
// 鏁扮粍鏍规嵁鏌愪釜key浠庡ぇ鍒板皬鎺掑簭
export function sortArrayByKey(arr, key) {
  return arr.sort((a, b) => b[key] - a[key]);
}
